import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Story from "./pages/Story";
import Locations from "./pages/Locations";
import FrdmBucks from "./pages/FrdmBucks";
import Contact from "./pages/Contact";
import Jobs from "./pages/Jobs";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/story" element={<Story />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/frdmbucks" element={<FrdmBucks />} />
          <Route path="/contact" element={<Contact />} />
          {/* Legacy / hidden pages — still accessible by direct URL */}
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
